module.exports = __webpack_public_path__ + "imgs/leafwell4.3a516e09a5d1eacd211ab6d44b7f8a55.svg";